import { defineStore } from "pinia";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import {
  langMap,
  routeMap,
  getKeyByValue,
  setLocaleFlag,
} from "@/util/dataProvider";
import TransLation from "@/i18n/translation";
// import { useI18n } from "vue-i18n";

export const useMetaDataStore = defineStore("metaData", () => {
  const route = useRoute();
  const metaData = ref();
  const locale = ref("english");
  // const { locale } = useI18n({});

  const loadLocaleData = async (localeKey) => {
    const localeName = getKeyByValue(langMap, routeMap[localeKey]);
    await TransLation.loadLocaleMessages(localeName);
    metaData.value = await importMetaData(routeMap[localeKey]);
  };

  const setLocale = async (lang) => {
    const langKey = getKeyByValue(langMap, routeMap[lang]);
    locale.value = langKey;
    const userLocale = TransLation.getUserLocale().localeNoRegion;
    const targetLocale = routeMap[lang] || routeMap[userLocale];
    if (langKey && targetLocale) {
      await loadLocaleData(lang);
    }
  };

  watch(
    () => route?.params?.lang,
    async (newVal) => {
      if (routeMap[newVal]) {
        setLocaleFlag(newVal);
        setLocale(newVal);
      } else {
        setLocaleFlag("en");
        locale.value = "english";
        importMetaData();
      }
    },
    { immediate: true },
  );

  async function importMetaData(lang = "english") {
    try {
      // Dynamically import the JSON file based on the `lang` parameter
      if (lang) {
        const data = await import(`../../data/metaData/${lang}MetaData.json`);
        const jsonData = data?.default || data;
        metaData.value = jsonData;
        return jsonData;
      }
    } catch (error) {
      const data = await import("../../data/metaData/englishMetaData.json");
      const jsonData = data?.default || data;
      metaData.value = jsonData;
      return jsonData;
    }
  }

  const getMetaData = computed(() => {
    if (metaData.value) return metaData.value;
    else return null;
  });

  const getLocale = computed(() => {
    return locale.value || "english";
  });

  return {
    getMetaData,
    setLocale,
    getLocale,
  };
});
